export default __webpack_public_path__ + "static/media/whatsapp.4cc16ca1.svg";